<template>
<div>
    <help-modal/>
    <div class="row" v-for="(contractorData, index) in contractorsData" v-bind:key="contractorData.contractor.id" a="index">
        <div class="col-md-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4 v-show="index === 0">{{ __('contractor_history') }}</h4>

                    <h4 v-show="index >= 1">{{ __('select_second_contractor') }}</h4>
                    <div class="ibox-tools">
                        <a v-show="index >= 1" @click="handleRemoveData(index)"
                           :title="__('delete')"
                           :data-original-title="__('delete')"
                           data-toggle="tooltip" data-placement="top">
                            <i class="fa fa-trash"></i>
                        </a>
                        <button-open-help-modal :helpName="helpName" :inExtraDiv="false"/>
                    </div>
                </div>
                <div class="ibox-content">
                    <div class="form-group row m-b-sm">
                        <div class="col-md-4">
                            <label>{{ __('contractor_name') }}*</label>
                            <select2 :options="index === 0 ? contractorsList : contractorsListFiltered"
                                     :settings="{ width: '100%' }"
                                     v-model="contractorIds[index]"
                                     @change="handleContractorChange(index)">

                            </select2>
                        </div>

                        <div class="col-md-2">
                            <label>{{ __('country_code') }}</label>
                            <input type="text" class="form-control" readonly :value="contractorData.contractor.country">
                        </div>
                        <div class="col-md-2">
                            <label>{{ __('identification_number_id') }}</label>
                            <input type="text" class="form-control" readonly :value="contractorData.contractor.identification_number_type">
                        </div>

                        <div class="col-md-4">
                            <label>{{ __('identification_number') }}*</label>
                            <select2 :options="index === 0 ? idNumbersList : idNumbersListFiltered"
                                     :settings="{ width: '100%' }"
                                     v-model="contractorIds[index]"
                                     @change="handleContractorChange(index)">
                            </select2>
                        </div>
                    </div>
                    <div class="form-group row" v-show="index === 0">
                        <div class="col-12">
                            <label><input type="checkbox" @click="handleShowNonZero"> {{ __('hide_zero_balances')}}</label>
                            <label><input type="checkbox" @click="handleShowZero"> {{ __('hide_non_zero_balances')}}</label>
                            <label><input type="checkbox" @click="handleShowRejected"> {{ __('show_rejected_and_cancelled')}}</label>
                            <label><input type="checkbox" @click="handleHideForeign"> {{ __('contractor_history_hide_foreign_documents')}}</label>
                            <label><input type="checkbox" @click="handleHideOwn"> {{ __('contractor_history_hide_own_documents')}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <operations-history v-if="getPermission(contractorData.permission_access, 'perm_view_summaries_contractor_history_payments')"
                :permission_access="contractorData.permission_access"
                :operations="contractorData.unallocated_payments"
                :return_url="return_url"
                :history_icon="false"
                :type="'contractor_history'"
                :contractor_id="contractorData.contractor.id"
                :allow_export="getPermission(contractorData.permission_access, 'perm_view_export_payments-and-unallocated-payments')"
                :index="index"
                :help-name="'ZRB-002'"
                @change="refreshAllContractorsData"
                @disableButtons="disableButtons()">
        </operations-history>

        <documents-history
                v-if="getPermission(contractorData.permission_access, 'perm_view_summaries_contractor_history_documents')"
                table_title="unallocated_documents"
                :allow_export="getPermission(contractorData.permission_access, 'perm_view_export_contractor_history')"
                :documents="contractorData.unallocated_documents"
                :permission_access="contractorData.permission_access"
                :contractor_id="contractorData.contractor.id"
                :index="index"
                :paginate="false"
                :help-name="'ZRB-003'"
                :show_due_date="false"
                :return_url="return_url"
                :section_balance="contractorData.unallocated_documents_balance"
                @change="refreshAllContractorsData"
                @disableButtons="disableButtons()"
        >
        </documents-history>

        <documents-history
                table_title="documents"
                v-if="getPermission(contractorData.permission_access, 'perm_view_summaries_contractor_history_documents')"
                :return_url="return_url"
                :documents="contractorData.documents"
                :permission_access="contractorData.permission_access"
                :contractor_id="contractorData.contractor.id"
                :index="index"
                :allow_export="getPermission(contractorData.permission_access, 'perm_view_export_contractor_history')"
                :section_balance="contractorData.documents_balance"
                :paginate="true"
                :meta="contractorData.documents_meta"
                :main_ids="contractorData.documents_main_ids"
                :help-name="'ZRB-004'"
                :show_due_date="true"
                @paginate="paginateDocuments"
                @change="refreshAllContractorsData">
        </documents-history>

        <payment-corrections-history
                 v-if="getPermission(contractorData.permission_access, 'perm_view_summaries_contractor_history_other_sources')"
                :permission_access="contractorData.permission_access"
                :payment_corrections="contractorData.payment_corrections"
                :contractor_id="contractorData.contractor.id"
                :index="index"
                :meta="contractorData.payment_corrections_meta"
                :main_ids="contractorData.payment_corrections_main_ids"
                @paginate="paginatePaymentCorrections"
                @change="refreshAllContractorsData">
        </payment-corrections-history>

    </div>

    <div class="row" v-if="addNextContractorVisible">
        <div class="col-md-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('select_second_contractor')}}</h4>
                    <div class="ibox-tools">
                        <a data-toggle="tooltip" data-placement="top" title="" :title="__('delete')" @click="addNextContractorVisible = false">
                            <i class="fa fa-trash"></i>
                        </a>
                    </div>
                </div>
                <div class="ibox-content">
                    <div class="form-group row m-b-sm">
                        <div class="col-md-4">
                            <label>{{ __('contractor_name') }}*</label>
                            <select2 :options="contractorsListFiltered"
                                     :settings="{ width: '100%' }"
                                     v-model="nextContractorId"
                                     @change="handleAddNextContractor">

                            </select2>
                        </div>

                        <div class="col-md-2">
                            <label>{{ __('country_code') }}</label>
                            <input type="text" class="form-control" readonly>
                        </div>
                        <div class="col-md-2">
                            <label>{{ __('identification_number_id') }}</label>
                            <input type="text" class="form-control" readonly >
                        </div>

                        <div class="col-md-4">
                            <label>{{ __('identification_number') }}*</label>
                            <select2 :options="idNumbersListFiltered"
                                     :settings="{ width: '100%' }"
                                     v-model="nextContractorId"
                                     @change="handleAddNextContractor">
                            </select2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" v-if="true">
        <modal-connect-with @save="refreshAllContractorsData"></modal-connect-with>
        <modal-generate-root-operation-balance></modal-generate-root-operation-balance>
        <modal-generate-balance @save="refreshAllContractorsData"></modal-generate-balance>

        <div class="ibox mb-0 cont-history" v-show="contractorsData.length >= 1">
            <div class="ibox-content">
                <div class="row">
                    <div class="col-10" v-if="contractorsData">
                        <button-show-modal-connect-with ref="button_show_modal_connect_with" v-if="getContractorPermission(contractorsData,  'perm_view_contractor_history_connect_with')" @view:refresh="refreshAllContractorsData"></button-show-modal-connect-with>
                        <button-show-modal-generate-balance v-if="getContractorPermission(contractorsData,  'perm_view_settlements')" @view:refresh="refreshAllContractorsData"></button-show-modal-generate-balance>
                        <strong>{{ __('selected') }}:</strong>
                        <span id="selected-info">{{ stripeInfo.text }}</span>
                        <span v-show="stripeInfo.tooltip != ''"
                              :title="stripeInfo.tooltip"
                              :data-original-title="stripeInfo.tooltip"
                              class="label label-default" data-toggle="tooltip" data-placement="top">...</span>
                        <button class="btn btn-primary btn-sm add-contractor"
                                @click="showAddNextContractor"
                                v-show="buttonAddNextContractorVisible">
                            {{ __('add_contractor')}}
                        </button>
                        <button-open-help-modal :help-name="'ZRB-007'" :inExtraDiv="false" :color="'black'" :left="50" :top="-10" :position="'fixed'" :right="25"/>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import actions from './../../vuex/action_types.js'
    import mutations from './../../vuex/mutation_types.js';
    import tooltips from './../../mixins/hasTooltips.js';
    import alerts from './../../mixins/updatesAlerts.js';
    import permissions from './../../services/Permissions.js';
    import HelpModal from '../../components/help/HelpModal.vue';
    import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue';
    import Vue from "vue";
    import Timer from "../session/Timer";

    Vue.component('timer', Timer);

    export default {
        components: { HelpModal, ButtonOpenHelpModal },
        name: "contractor-history-local",
        mixins: [tooltips, alerts],
        data: function () {
            return {
                nextContractorId: 0,
                addNextContractorVisible: false,
                contractorIds: [],
                selectSecondContractorVisible: false,
                pagination: {},
                helpName: 'ZRB-001',
                helpNameGenerateBalance: 'ZRB-006',
                helpNameConnectWith: 'ZRC-001',
                helpsConnectWith: [
                    "ZRC-001", "ZRD-001", "ZRI-001", "ZRG-001", "ZRH-001", "ZRE-001", "ZRF-001"
                ]
            }
        },
        props: ['allow_export', 'return_url'],
        methods: {
            disableButtons:function (){
                this.$refs.button_show_modal_connect_with.disabled = true;
            },
            handleRemoveData: function(index) {
                const id = this.contractorsData[index].contractor.id;

                const _for_removal = [];
                this.selected.forEach(item => {
                    if (item.contractor_id === id) this.$store.commit(item.type === 'document' ? mutations.REMOVE_DOCUMENT : mutations.REMOVE_OPERATION, item.id);
                    _for_removal.push(item);
                });

                _for_removal.forEach(item => this.$store.commit(mutations.REMOVE_SELECTED, item));

                this.$store.commit(mutations.REMOVE_CONTRACTOR_DATA, index);
                this.contractorIds.splice(this.contractorIds.indexOf(id), 1);
            },
            handleContractorChange: function(index) {
                if(index === 0){
                    if(this.contractorIds[index] === 0 || this.contractorIds[index] === '0'){
                        location.href = '/summaries/contractor-history';
                    }
                    else{
                        location.href = '/summaries/contractor-history/' + this.contractorIds[0]
                        this.fetchContractorData(index);
                    }
                }
                else{
                    if(this.contractorIds[index] !== 0 && this.contractorIds[index] !== '0'){
                        this.fetchContractorData(index);
                    }
                    else{
                        this.$store.dispatch(actions.RESET_CONTRACTOR_HISTORY,{
                            index: index
                        })
                    }
                }

            },
            handleAddNextContractor: function() {
                this.contractorIds.push(this.nextContractorId);
                if(this.nextContractorId !== 0 && this.nextContractorId !== "0"){
                    this.$store.dispatch(actions.FETCH_CONTRACTOR_HISTORY,{
                        contractor_id: this.nextContractorId,
                        index: this.contractorIds.length - 1
                    }).then(result => {
                        setTimeout(function() {
                            window.scrollTo(0,document.body.scrollHeight);
                        }, 100);
                    });
                    this.nextContractorId = 0;
                    this.addNextContractorVisible = false;
                }

            },
            handleShowNonZero: function(event) {
                this.contractorIds.forEach((id, index) => {
                    if(event.target.checked) {
                        this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                            index: index,  params: { 'non_zero': true, }
                        })
                    } else {
                        this.$store.commit(mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM, {
                            index: index, param: 'non_zero'
                        })
                    }
                });
                this.refreshAllContractorsData();
            },
            handleShowZero: function(event) {
                this.contractorIds.forEach((id, index) => {
                    if(event.target.checked) {
                        this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                            index: index,  params: { 'zero': true, }
                        })
                    } else {
                        this.$store.commit(mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM, {
                            index: index, param: 'zero'
                        })
                    }
                });
                this.refreshAllContractorsData();
            },
            handleShowRejected: function(event) {
                this.contractorIds.forEach((id, index) => {
                    if(event.target.checked) {
                        this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                            index: index,  params: { 'rejected': true, }
                        })
                    } else {
                        this.$store.commit(mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM, {
                            index: index, param: 'rejected'
                        })
                    }
                });
                this.refreshAllContractorsData();
            },
            handleHideForeign: function(event) {
                this.contractorIds.forEach((id, index) => {
                    if(event.target.checked) {
                        this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                            index: index,  params: { 'hide-foreign': true, }
                        })
                    } else {
                        this.$store.commit(mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM, {
                            index: index, param: 'hide-foreign'
                        })
                    }
                });
                this.refreshAllContractorsData();
            },
            handleHideOwn: function(event) {
                this.contractorIds.forEach((id, index) => {
                    if(event.target.checked) {
                        this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                            index: index,  params: { 'hide-own': true, }
                        })
                    } else {
                        this.$store.commit(mutations.REMOVE_CONTRACTOR_HISTORY_GET_PARAM, {
                            index: index, param: 'hide-own'
                        })
                    }
                });
                this.refreshAllContractorsData();
            },
            showAddNextContractor: function() {
                this.addNextContractorVisible = true;
                setTimeout(function() {
                    window.scrollTo(0,document.body.scrollHeight);
                }, 100);
            },
            paginateDocuments: function (data) {
                this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                    index: data.props.index,
                    params: {
                        'documents-per-page': data.per_page,
                        'documents-page': data.page,
                    }
                });
                this.fetchContractorData(data.props.index);
            },
            paginatePaymentCorrections: function(data) {
                this.$store.commit(mutations.ADD_CONTRACTOR_HISTORY_GET_PARAMS, {
                    index: data.props.index,
                    params: {
                        'payment-corrections-per-page': data.per_page,
                        'payment-corrections-page': data.page,
                    }
                });
                this.fetchContractorData(data.props.index);
            },
            refreshContractorData: function(data) {
                this.$store.dispatch(actions.FETCH_CONTRACTOR_HISTORY, {
                        index: data.props.index,
                        contractor_id: data.props.contractor_id })
                    .then(response => toastr['success'](this.__(data.message)).css('border', '0px'));
            },
            fetchContractorData: function(index) {
                this.$store.dispatch(actions.FETCH_CONTRACTOR_HISTORY,{
                    contractor_id: this.contractorIds[index],
                    index: index
                });
            },
            refreshAllContractorsData: function() {
                this.$store.dispatch(actions.REFRESH_CONTRACTOR_HISTORY, {})
                    .then(response => this.$_updatePaymentAndUnallocatedDocumentAlert())
            },
            getPermission: function(permission_access, permission) {
                return permissions.getPermission(permission_access, permission);
            },
            getContractorPermission: function(contractor, permission) {
                if (typeof contractor[0] !== "undefined") {
                    return permissions.getPermission(contractor[0].permission_access, permission);
                }
                return false;
            }
        },
        computed: {
            contractorsData: function() { return this.$store.getters.getContractorsData },
            selected: function() { return this.$store.getters.getSelected; },
            stripeInfo: function() {
                let selected = this.$store.getters.getSelected;
                let info = [];
                selected.forEach(item => info.push(item.stripe_info));
                return {
                    text: info.slice(0,3).join(' | '),
                    tooltip: info.slice(3).join(' <br> '),
                };
            },
            userInfo: function() { return this.$store.getters.getUserInfo },
            contractorsListFiltered: function() {
                return this.contractorsList.filter(optionItem => optionItem.id != this.contractorIds[0] && !optionItem.is_global)
            },
            idNumbersListFiltered: function() {
                return this.idNumbersList.filter(optionItem => optionItem.id != this.contractorIds[0] && !optionItem.is_global)
            },
            contractorsList: function() { return this.$store.getters.getSelect2ContractorsList },
            idNumbersList: function() { return this.$store.getters.getSelect2IdNumbersList },
            buttonAddNextContractorVisible: function() { return ((!this.addNextContractorVisible) && (this.contractorIds.length < 2))}
        },
        mounted: function() {
            this.$store.dispatch(actions.FETCH_SELECT2_CONTRACTORS_LIST);
            let contractor_id = window.location.toString().split('/').pop();
            contractor_id = contractor_id.replace('?showModal=false#', '').replace('?showModal=false', '')
            this.contractorIds.push(contractor_id);
            if(contractor_id !== ""){
                this.$store.dispatch(actions.FETCH_CONTRACTOR_HISTORY,{contractor_id:contractor_id, index: 0});
            }

        },
    }
</script>

<style scoped>
    .add-contractor {
        display: block;
        position: fixed;
        right: 50px;
        bottom: 15px;
    }
</style>
